import { Button } from "@progress/kendo-react-buttons";
import React, { useContext, useEffect, useRef, useState } from "react";
import { RxCaretRight } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { dataAPI, getCookie } from "../../api/axios";
import MapContext from "../MapContext";
import { getFeatureWithId, getMapLayerById } from "../utils/mapUtils";
import GPSTrimble from "./GPSTrimble";
import NewFeature from "./NewFeature";
import "./Editing.css";
import EditFeature from "./EditFeature";

import jwt_decode from "jwt-decode";
import { makeArray } from "../../permissionUtils";

const EditingOptions = () => {
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const permissions = useSelector((state) => state.configData.permissions);
    const layerVisProperties = useSelector(
        (state) => state.configData.layerVisProperties
    );
    const token = getCookie("ast");
    let tokenRoles = ["GUEST"];
    if (token) {
        tokenRoles = jwt_decode(token).realm_access.roles;
    }
    const editMode = useSelector((state) => state.editingOptions.activeCreateFeatureTool);
    const editEditFeatureId = useSelector(
        (state) => state.editingOptions.currentEditFeature
    );
    const editLayerID = useSelector((state) => state.editingOptions.currentEditLayer);

    const [selectedLayer, setSelectedLayer] = useState();
    const { map } = useContext(MapContext);
    let createLayers = mapConfig.AddLayers;
    let editLayers = mapConfig.EditLayers;
    useEffect(() => {
        if (!mapConfig && !permissions) {
            return;
        } else {
            if (editMode && editLayerID) {
                if (editMode === "editfeature") {
                    let l = mapConfig.EditLayers.filter((i) => {
                        return i.Id === editLayerID;
                    })[0];
                    if (l) {
                        setSelectedLayer(l);
                    }
                }
            }
        }
    }, [mapConfig, permissions, editMode, editLayerID, editEditFeatureId]);

    const returnFromChildHandler = (data) => {
        setSelectedLayer(undefined);
    };

    return (
        <>
            {createLayers && createLayers.length === 0 && (
                <>
                    <h3 className="title">Edit</h3>
                    <p>No Editable Features Available</p>
                </>
            )}
            {createLayers && createLayers.length > 0 && !selectedLayer && (
                <>
                    <h3 className="title">Select Feature Type</h3>
                    {createLayers.map((el) => (
                        <div
                            className="edit-item"
                            key={el.Id}
                            onClick={(e) => {
                                setSelectedLayer(el);
                            }}>
                            <h4>{el.DisplayName}</h4>
                            <button
                                className="arrow-button"
                                key={el.LayerID + "_button"}
                                onClick={(e) => {
                                    setSelectedLayer(el);
                                }}>
                                <RxCaretRight />
                            </button>
                        </div>
                    ))}
                </>
            )}
            {selectedLayer && !editEditFeatureId && (
                <NewFeature
                    prop={{
                        selectedLayer: selectedLayer,
                        returnToParent: returnFromChildHandler,
                    }}
                />
            )}
            {selectedLayer && editEditFeatureId && (
                <EditFeature
                    prop={{
                        selectedLayer: selectedLayer,
                        returnToParent: returnFromChildHandler,
                    }}
                />
            )}
        </>
    );
};
export default EditingOptions;
